import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './phonenumber.module.css';
import axios from '../../axiosdata';
import Button from '../../UI/Buttons/Button'

class PhonenumberEditor extends Component {

    state = {
        id: this.props.information && this.props.information[0] ? this.props.information[0].id : null,
        phonenumber: this.props.information && this.props.information[0] ? this.props.information[0].phonenumber : '',
        saveError: null
    }

    setNewNumber = () => {
        const data = {
            phonenumber: this.state.phonenumber
        }
        axios.patch(`/information/${this.state.id}.json`, data)
        .then(() => this.props.onSuccess())
        .catch(() => this.setState({ saveError: 'Tallennus epäonnistui. Yritä uudelleen.' }));
    }


    handleChange = (event) => {
        this.setState({phonenumber: event.target.value});
    }


    render(){
        return(
            <div className={classes.infoContainer}>
                <h3>Puhelinnumero</h3>
                <input type="text" value={this.state.phonenumber} onChange={this.handleChange}/>
                {this.state.saveError ? <div style={{color: 'red', marginBottom: '8px'}}>{this.state.saveError}</div> : null}
                <Button click={this.setNewNumber}>Tallenna</Button>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        information: state.information.data
    }
}

const mapDispatchToProps = dispatch => {
    return{
        
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(PhonenumberEditor);